// TextElement

var TextElement = (function() {

  var config = {
    canvas: {
      grid: true,
      density: 1,
    },
  };

  function TextElement(options) {

    options = options || {};

    if (!options.layer ||
      !options.layer.canvas ||
      !options.layer.canvas.context
    ) return;

    var self = this;

    this.value = options.value || "Some example *dynamic text* for preview.";
    this.context = options.layer.canvas.context;
    this.canvas = this.context.canvas;
    this.editing = options.editing || false;
    this.debug = options.debug || {};
    this.layer = options.layer || {};
    this.layer.text = this;

    this.style = options.style || "light";
    this.shape = new ShapeElement(options);

    var font = options.font || {};
    var align = font.alignment || {};
    this.font = {
      face: font.face || "dynamic",
      regular: font.regular || "whizbang-roman",
      bold: font.bold || "whizbang-bold",
      size: font.size || 7,
      color: font.color || "#000",
      baseline: font.baseline || "hanging",
      leading: font.leading != undefined ? font.leading : 2,
      padding: font.padding != undefined ? font.padding : 10,
      overflow: TextElement.Overflow.NONE, // font.overflow
      alignment: {
        vertical: align.vertical || TextElement.VerticalAlignment.CENTER,
        horizontal: align.horizontal || TextElement.HorizontalAlignment.CENTER,
      },
    };

    TextController.events.on("canvas-mousedown", onMouseDown.bind(this));
    TextController.events.on("canvas-mousemove", onMouseMove.bind(this));
    TextController.events.on("canvas-mouseup", onMouseUp.bind(this));

    this.resetCanvas();
    this.resetDefaults(true);

    setTimeout(function() {
      self.updateCanvas();
    }, 250);

    return this;

  }

  // Method to render the text element
  TextElement.prototype.resetCanvas = function(drawGrid) {

    this.canvas.width = Canvas.size.width; //this.canvas.offsetWidth * 2;
    this.canvas.height = Canvas.size.height; //this.canvas.offsetHeight * 2;

    if (!this.editing || !this.debug.grid) return;

    this.context.save();

    this.context.strokeStyle = "#999";
    this.context.lineWidth = 3;

    for (var i = 1; i < this.canvas.width / 100; i++) {
      this.context.lineWidth = this.context.lineWidth === 3 ? 1 : 3;
      this.context.beginPath();
      this.context.moveTo(100 * i, 0);
      this.context.lineTo(100 * i, this.canvas.height);
      this.context.stroke();
    }

    for (var i = 1; i < this.canvas.height / 100; i++) {
      this.context.lineWidth = this.context.lineWidth === 3 ? 1 : 3;
      this.context.beginPath();
      this.context.moveTo(0, 100 * i);
      this.context.lineTo(this.canvas.width, 100 * i);
      this.context.stroke();
    }

    this.context.restore();

  };

  // Method to reset flags used for moving / resizing back to their defaults
  TextElement.prototype.resetDefaults = function(includeHovers) {

    this.isResizing = false;
    this.isMovingPanel = false;
    this.isMovingTailPoint = false;
    this.isMovingTailControl = false;
    this.isMovingTailIntersect = false;
    this.isMovingTopLeft = false;
    this.isMovingTopRight = false;
    this.isMovingBottomLeft = false;
    this.isMovingBottomRight = false;

    this.initialOffset = new Vector2();
    this.initialScale = new Vector2();
    this.initialBounds = new Bounds();
    this.initialPanel = new Bounds();

    if (includeHovers !== true) return;

    this.isOverPanel = false;
    this.isOverTailPoint = false;
    this.isOverTailControl = false;
    this.isOverTailIntersect = false;
    this.isOverTopLeft = false;
    this.isOverTopRight = false;
    this.isOverBottomLeft = false;
    this.isOverBottomRight = false;

  };

  // Method to render the text element
  TextElement.prototype.updateCanvas = function(isDragging, skipRender) {

    this.resetCanvas();
    this.shape.updateCanvas(this.editing, isDragging);
    this.drawText();

    if (!skipRender) Comic.renderPage();

  };

  // Method to draw the text to the canvas
  TextElement.prototype.drawText = function() {

    this.context.save();

    var fontSize = this.font.size * this.shape.scale;

    this.context.font = fontSize + "px " + this.font.regular;
    this.context.textBaseline = this.font.baseline;
    this.context.fillStyle = this.font.color;

    var text = this.formatText();
    var index = 0;
    var length = text.lines.length;

    for (; index < length; index++) {
      this.drawTextLine(text, index);
    }

    this.context.restore();

  };

  // Method to draw the line array of words to the canvas
  TextElement.prototype.drawTextLine = function(text, row) {

    var self = this;
    var line = text.lines[row];

    var fontHeight = this.shape.scale * (this.font.leading + this.font.size);
    var fontLeading = this.shape.scale * this.font.leading;
    var fontPadding = this.shape.scale * this.font.padding;

    var textPanel = new Bounds(
      this.shape.panel.top + fontPadding,
      this.shape.panel.left + fontPadding,
      this.shape.panel.width - (fontPadding * 2),
      this.shape.panel.height - (fontPadding * 2)
    );
    var textHeight = (row * fontHeight) + fontLeading;
    var textCursor = new Vector2();
    var textY = text.offset.y;

    switch (this.font.alignment.horizontal) {
      case TextElement.HorizontalAlignment.LEFT:
        textCursor.x = 0;
        break;
      case TextElement.HorizontalAlignment.RIGHT:
        textCursor.x = textPanel.width - line.width;
        break;
      case TextElement.HorizontalAlignment.CENTER:
      default:
        textCursor.x = (textPanel.width - line.width) / 2;
        break;
    }

    switch (this.font.alignment.vertical) {
      case TextElement.VerticalAlignment.TOP:
        textCursor.y = textHeight;
        break;
      case TextElement.VerticalAlignment.BOTTOM:
        textCursor.y = (textPanel.height - textY) + textHeight - fontLeading - fontPadding;
        break;
      case TextElement.VerticalAlignment.CENTER:
      default:
        textCursor.y = ((textPanel.height - fontHeight - textY) / 2) + textHeight;
        break;
    }

    var index = 0;
    var length = line.words.length;
    var word = line.words[index];
    var position = new Vector2();

    for (; index < length; index++) {
      word = line.words[index];
      position = new Vector2(
        textPanel.left + textCursor.x,
        textPanel.top + textCursor.y
      );
      textCursor.x += word.width;
      this.context.font = word.font;
      this.context.fillStyle = this.font.color;
      this.context.fillText(word.text, position.x, position.y);
    }

  }

  // Method to measure the text spaces
  TextElement.prototype.measureTextSpaces = function() {

    var fontSize = (this.font.size * this.shape.scale) + "px ";
    var spaceSize = {
      regular: 0,
      bold: 0
    };

    this.context.font = fontSize + this.font.regular;
    spaceSize.regular = this.context.measureText(" ").width;

    this.context.font = fontSize + this.font.bold;
    spaceSize.bold = this.context.measureText(" ").width;

    return spaceSize;

  };

  // Method to format the text into line / word arrays
  TextElement.prototype.formatText = function() {

    var line = {
      words: [],
      width: 0
    };

    var textHeight = (this.font.size + this.font.leading) * this.shape.scale;
    var textCursor = new Vector2();
    var textPadding = this.font.padding * this.shape.scale;
    var textPanel = {
      width: this.shape.panel.width - (textPadding * 2),
      height: this.shape.panel.height - (textPadding * 2),
    };

    var formatted = this.formatTextWords(this.value);

    var isOverflowing = false;

    var index = 0;
    var length = formatted.length;
    var word = formatted[index];

    this.lines = [];

    for (; index < formatted.length; index++) {

      word = formatted[index];

      // Check for the line-break character to start a new line
      if (word.value === "{{line-break}}") {
        line.width = textCursor.x;
        this.lines.push(line);
        line = {
          words: [],
          width: 0
        };
        textCursor.x = 0;
        textCursor.y += textHeight;
        // Check for vertical overflowing and only continue if the line will fit
        if (textCursor.y - textHeight <= textPanel.height) continue;
        // Otherwise set the overflow flag and modify the line(s) if necessary
        isOverflowing = true;
        // If overflow is set to hidden, exit the loop
        if (this.font.overflow === TextElement.Overflow.HIDDEN ||
          this.font.overflow === TextElement.Overflow.ELLIPSIS) {
          break;
        }
        continue;
      }

      // Check if the word will fit on the line
      if (textCursor.x + word.width <= textPanel.width) {
        // Check if the a space will fit on the line
        if (textCursor.x + word.width + word.space <= textPanel.width) {
          word.text += " ";
          word.width += word.space;
        }
        textCursor.x += word.width;
        line.words.push(word);
        continue;
      }

      // Check previous line for trailing space to remove
      var lastWord = line.words[line.words.length - 1];
      if (lastWord && lastWord.text.indexOf(" ") > -1) {
        lastWord.text = lastWord.text.replace(" ", "");
        lastWord.width -= word.space;
        textCursor.x -= word.space;
      }

      // Otherwise if the line will overflow, create a new line
      line.width = textCursor.x;
      this.lines.push(line);

      // Add a space after the first word of the line
      word.text += " ";
      word.width += word.space;

      // Reset the line with the single word
      line = {
        words: [word],
        width: word.width
      };

      // Reset the width offset and add to the height
      textCursor.x = word.width;
      textCursor.y += textHeight;

      // Check for vertical overflowing and only continue if the line will fit
      if (textCursor.y - textHeight <= textPanel.height) continue;

      // Otherwise set the overflow flag and modify the line(s) if necessary
      isOverflowing = true;

      // If overflow is set to hidden, exit the loop
      if (this.font.overflow === TextElement.Overflow.HIDDEN ||
        this.font.overflow === TextElement.Overflow.ELLIPSIS) {
        break;
      }

    }

    if (isOverflowing) {
      textCursor.y -= textHeight;
      // If the overflow is set to ellipsis, tuncate and add dots
      if (this.font.overflow === TextElement.Overflow.ELLIPSIS) {
        this.formatTextEllipsis();
      }
    } else {
      // Check previous line for trailing space to remove
      var lastWord = line.words[line.words.length - 1];
      if (lastWord && lastWord.text.indexOf(" ") > -1) {
        lastWord.text = lastWord.text.replace(" ", "");
        lastWord.width -= word.space;
        textCursor.x -= word.space;
      }
      line.width = textCursor.x;
      this.lines.push(line);
    }

    return {
      lines: this.lines,
      offset: textCursor,
    };

  };

  // Method to format the text words
  TextElement.prototype.formatTextWords = function(value) {

    var words = [];
    var lines = value.split("\n");
    for (var i = 0; i < lines.length; i++) {
      words = words.concat(lines[i].split(" "));
      if (i < lines.length - 1) words.push("{{line-break}}");
    }

    var formatted = [];
    var word = {};
    var text = "";
    var slice = 0;

    var textSpaces = this.measureTextSpaces();
    var textPadding = this.font.padding * this.shape.scale;
    var textPanel = {
      width: this.shape.panel.width - (textPadding * 2),
      height: this.shape.panel.height - (textPadding * 2),
    };

    // HACK: Min bounds
    var minBounds = (new Vector2(125, 75)).scale(config.canvas.density);
    if (textPanel.width < minBounds.x) textPanel.width = minBounds.x;
    if (textPanel.height < minBounds.y) textPanel.height = minBounds.y;

    var fontSize = (this.font.size * this.shape.scale) + "px ";
    var fontBold = false;

    var index = 0;
    var length = words.length;

    for (; index < length; index++) {

      word = {
        value: words[index],
        text: words[index],
        font: fontSize + this.font.regular,
        width: 0,
        space: textSpaces.regular,
      };

      var match = /\r|\n/.exec(word.value);
      // Check for opening bold character
      if (this.font.face === "dynamic" && word.value.indexOf("*") === 0) {
        word.text = word.value.slice(1, word.value.length);
        fontBold = true;
      }

      if (this.font.face === "whizbang-bold" || fontBold) {
        word.font = fontSize + this.font.bold;
        word.space = textSpaces.bold;
      }

      // Check for closing bold character
      if (this.font.face === "dynamic" && word.text.indexOf("*") > -1) {
        word.text = word.text.replace("*", "");
        fontBold = false;
      }

      // Measure the width of the word with the set font
      this.context.font = word.font;
      word.width = this.context.measureText(word.text).width;

      // Check if the word overflows the panel, split it if necessary
      if (word.width < textPanel.width) {
        // Add the data to the list
        formatted.push(word);
        // Skip to the next iteration
        continue;
      }

      var max = 100; // HACK
      var int = 0; // HACK

      // Loop while the word overflows the panel
      while (this.context.measureText(word.text).width > textPanel.width && int < max) {

        int += 1;

        // Reset default values
        slice = 0;
        text = word.text;

        // Loop while the word fragment overflows the panel
        while (this.context.measureText(text + "-").width > textPanel.width && int < max) {
          slice++;
          // Remove a character from the end
          text = word.text.slice(0, word.text.length - 1 - slice);
        }

        if (text !== "") {
          formatted.push({
            value: word.value,
            text: text + "-",
            font: word.font,
            width: this.context.measureText(text + "-").width,
            space: word.space,
          });
        }

        word.text = word.text.slice(text.length, word.text.length);
        word.width = this.context.measureText(word.text).width;

      }

      // Add the data to the list
      formatted.push(word);

    }

    return formatted;

  }

  // Method to format the text into line / word arrays
  TextElement.prototype.formatTextEllipsis = function() {

    var lastLine = this.lines[this.lines.length - 1];
    var lastIndex = lastLine.words.length - 1;
    var lastWord = lastLine.words[lastIndex];

    if (lastWord) {

      var lastWidth = lastWord.width;
      if (lastWord.text.indexOf(" ") > -1) {
        lastWord.text = lastWord.text.replace(" ", "");
      }
      lastWord.text += "...";
      this.context.font = lastWord.font;
      lastWord.width = this.context.measureText(lastWord.text).width;
      lastLine.width += lastWord.width - lastWidth;

    } else {

      lastLine.words.push({
        value: "...",
        text: "...",
        font: (this.font.size * this.shape.scale) + "px " + this.font.regular,
        width: this.context.measureText("...").width,
        space: this.measureTextSpaces().regular,
      });
      lastLine.width = lastLine.words[0].width;

    }

  };

  // Method to compare the mouse coords with the handles on mouse down
  TextElement.prototype.handleOnMouseDown = function(position) {

    var shape = this.shape;
    var tail = shape.tail;
    var points = tail.points;
    var offset = new Vector2(shape.bounds.left, shape.bounds.top);

    this.initialOffset = new Vector2();
    this.initialScale = shape.scale;
    this.initialBounds = shape.getBounds();
    this.initialPanel = shape.getPanelBounds();

    if (this.isOverTopLeft) {
      this.isMovingTopLeft = true;
      this.isResizing = true;
    } else if (this.isOverTopRight) {
      this.isMovingTopRight = true;
      this.isResizing = true;
    } else if (this.isOverBottomLeft) {
      this.isMovingBottomLeft = true;
      this.isResizing = true;
    } else if (this.isOverBottomRight) {
      this.isMovingBottomRight = true;
      this.isResizing = true;
    } else if (
      (tail.type === "curved") //  || tail.type === "thought"
      &&
      this.isOverTailControl
    ) {
      this.isMovingTailControl = true;
      this.initialOffset = new Vector2(tail.control.x, tail.control.y);
    } else if (tail.type !== "none" && this.isOverTailIntersect) {
      this.isMovingTailIntersect = true;
      this.initialOffset = new Vector2(points.intersect.x, points.intersect.y);
    } else if (tail.type !== "none" && this.isOverTailPoint) {
      this.isMovingTailPoint = true;
      this.initialOffset = new Vector2(points.tail.x, points.tail.y);
    } else {
      this.isMovingPanel = shape.bounds.contains(position, config.canvas.density);
      if (this.isMovingPanel) {
        this.initialOffset = new Vector2(offset.x, offset.y);
        this.initialPanel = new Vector2(shape.panel.left, shape.panel.top);
      }
    }

  }

  // Method to handle on mouse drag
  TextElement.prototype.handleOnMouseDrag = function(position, offset) {

    var shape = this.shape;
    var bounds = shape.bounds;

    if (this.isResizing) {
      this.handleOnShapeResize(position, offset);
    } else if (this.isMovingPanel) {
      this.handleOnShapeMove(position, offset);
    } else if (this.isMovingTailPoint) {
      this.handleOnTailPointMove(position, offset);
    } else if (this.isMovingTailIntersect) {
      this.handleOnTailIntersectMove(position, offset);
    } else if (this.isMovingTailControl) {
      this.handleOnTailControlMove(position, offset);
    }

  };

  // Method to handle on mouse over
  TextElement.prototype.handleOnMouseOver = function(position, offset) {

    var shape = this.shape;
    var scale = shape.scale;
    var density = config.canvas.density;
    var tail = {
      position: shape.tail.position,
      radius: shape.tail.handle.radius, // / density,
      intersect: shape.tail.points.intersect.scale(2), // HACK
      control: shape.tail.points.control.scale(2),
    };

    this.isOverPanel = shape.bounds.contains(position, config.canvas.density);

    if (shape.tail.type !== "none") {
      // console.log("tail", position, tail.position, position.distanceTo(tail.position), tail.radius);
      this.isOverTailPoint = position.distanceTo(tail.position) < tail.radius;
      this.isOverTailIntersect = position.scale(1 / density).distanceTo(tail.intersect) < 10 / density;
      if (shape.tail.type === "curved") { //  || shape.tail.type === "thought"
        this.isOverTailControl = position.scale(1 / density).distanceTo(tail.control) < 10 / density;
      }
    }

    this.isOverTopLeft = position.distanceTo(new Vector2(
      shape.bounds.left / density,
      shape.bounds.top / density
    )) < 20;

    this.isOverTopRight = position.distanceTo(new Vector2(
      shape.bounds.right / density,
      shape.bounds.top / density
    )) < 20;

    this.isOverBottomLeft = position.distanceTo(new Vector2(
      shape.bounds.left / density,
      shape.bounds.bottom / density
    )) < 20;

    this.isOverBottomRight = position.distanceTo(new Vector2(
      shape.bounds.right / density,
      shape.bounds.bottom / density
    )) < 20;

    if (!this.debug.hover) return;

    if (this.isOverTopLeft) {
      console.log("isOverTopLeft");
    } else if (this.isOverTopRight) {
      console.log("isOverTopRight");
    } else if (this.isOverBottomLeft) {
      console.log("isOverBottomLeft");
    } else if (this.isOverBottomRight) {
      console.log("isOverBottomRight");
    } else if (this.isOverTailIntersect) {
      console.log("isOverTailIntersect");
    } else if (this.isOverTailControl) {
      console.log("isOverTailControl");
    } else if (this.isOverPanel) {
      console.log("isOverPanel");
    } else if (this.isOverTailPoint) {
      console.log("isOverTailPoint");
    }

  };

  // Method to handle on resize of the text element
  TextElement.prototype.handleOnShapeResize = function(position, offset) {

    var shape = this.shape;
    var bounds = shape.bounds;

    var resizeOffset = new Vector2(
      this.initialOffset.x + (offset.x / shape.scale),
      this.initialOffset.y + (offset.y / shape.scale)
    );
    var scaledOffset = new Vector2(
      resizeOffset.x * config.canvas.density * shape.scale,
      resizeOffset.y * config.canvas.density * shape.scale
    );
    var scaledBounds = new Vector2(
      this.initialBounds.width + scaledOffset.x,
      this.initialBounds.height + scaledOffset.y
    );
    var positionOffset = new Vector2();

    if (this.isMovingTopLeft) {
      scaledBounds = new Vector2(
        this.initialBounds.width - scaledOffset.x,
        this.initialBounds.height - scaledOffset.y
      );
      positionOffset = new Vector2(scaledOffset.x, scaledOffset.y);
    } else if (this.isMovingTopRight) {
      scaledBounds = new Vector2(
        this.initialBounds.width + scaledOffset.x,
        this.initialBounds.height - scaledOffset.y
      );
      positionOffset = new Vector2(0, scaledOffset.y);
    } else if (this.isMovingBottomLeft) {
      scaledBounds = new Vector2(
        this.initialBounds.width - scaledOffset.x,
        this.initialBounds.height + scaledOffset.y
      );
      positionOffset = new Vector2(scaledOffset.x, 0);
    }

    // HACK: Min bounds
    if (scaledBounds.x < 125 * config.canvas.density) scaledBounds.x = shape.bounds.width;
    if (scaledBounds.y < 75 * config.canvas.density) scaledBounds.y = shape.bounds.height;

    shape.bounds.move(
      this.initialBounds.left + positionOffset.x,
      this.initialBounds.top + positionOffset.y
    );

    shape.resizeShape(scaledBounds);

    this.updateCanvas(true);

  };

  // Method to handle on move of the shape
  TextElement.prototype.handleOnShapeMove = function(position, offset) {

    var scale = config.canvas.density;
    var x = this.initialBounds.left + (offset.x * scale);
    var y = this.initialBounds.top + (offset.y * scale);

    this.shape.bounds.move(x, y);

    this.updateCanvas(true);

  };

  // Method to handle on move of the tail point
  TextElement.prototype.handleOnTailPointMove = function(position, offset) {

    // this.shape.tail.custom.tail = true;

    this.shape.tail.position.x = position.x * config.canvas.density;
    this.shape.tail.position.y = position.y * config.canvas.density;

    this.updateCanvas();

  };

  // Method to handle on move of the tail intersect point
  TextElement.prototype.handleOnTailIntersectMove = function(position, offset) {

    var add = position.scale(1 / 2); // HACK

    this.shape.tail.custom.intersect = true;
    this.shape.tail.points.intersect = add; //this.initialOffset.add(add);

    // this.shape.pointClosestToMouse = position;
    // this.shape.tail.position = position;

    this.updateCanvas(true);

  };

  // Method to handle on move of the tail control point
  TextElement.prototype.handleOnTailControlMove = function(position, offset) {

    var scaled = offset.scale(1 / 2); // HACK

    // this.shape.tail.custom.control = true;
    this.shape.tail.control.x = scaled.x + this.initialOffset.x;
    this.shape.tail.control.y = scaled.y + this.initialOffset.y;

    this.updateCanvas();

  };

  // TODO Method to generate a static canvas
  TextElement.prototype.generateStaticCanvas = function(callback) {

    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");

    canvas.width = this.canvas.width;
    canvas.height = this.canvas.height;
    context.drawImage(this.context.canvas, 0, 0);

    return canvas;

  };

  // TODO Method to generate an image of the text element canvas
  TextElement.prototype.generateImage = function(callback) {

    var self = this;
    var data = this.context.canvas.toDataURL("image/png");

    Asset.loadImage(data, function(image) {
      callback && callback(image, data);
    });

  };

  // Method to generate an export of the text element data
  TextElement.prototype.generateExport = function() {

    var text = {

      value: this.value,
      style: this.style,

      font: {
        face: this.font.face,
        size: this.font.size,
        color: this.font.color,
        baseline: this.font.baseline,
        leading: this.font.leading,
        padding: this.font.padding,
        overflow: this.font.overflow,
        alignment: {
          vertical: this.font.alignment.vertical,
          horizontal: this.font.alignment.horizontal,
        },
      },

      shape: {
        bounds: this.shape.bounds.toObject(),
        outline: this.shape.outline.id,
        scale: this.shape._scale,
        color: this.shape.color,
        border: {
          color: this.shape.border.color,
          size: this.shape.border.size,
          dash: this.shape.border.dash,
        },
      },

      tail: {
        type: this.shape.tail.type,
        position: this.shape.tail.position.toObject(),
        width: this.shape.tail.width,
        control: this.shape.tail.control.toObject(),
        intersect: this.shape.tail.points.intersect.toObject(),
      },

    };

    return JSON.parse(JSON.stringify(text));

  };

  // Text overflow options
  TextElement.Overflow = {
    NONE: "NONE",
    ELLIPSIS: "ELLIPSIS",
    HIDDEN: "HIDDEN",
    LOCKED: "LOCKED",
  };

  // Text vertical alignment options
  TextElement.VerticalAlignment = {
    TOP: "TOP",
    CENTER: "CENTER",
    BOTTOM: "BOTTOM",
  };

  // Text horizontal alignment options
  TextElement.HorizontalAlignment = {
    LEFT: "LEFT",
    CENTER: "CENTER",
    RIGHT: "RIGHT",
  };

  // Method to handle the onMouseDown event
  function onMouseDown(data) {

    if (!this.editing) return;

    this.handleOnMouseDown(data.currentPosition);

  }

  // Method to handle the onMouseMove event
  function onMouseMove(data) {

    if (!this.editing) return;

    if (data.isDragging) {
      this.handleOnMouseDrag(data.currentPosition, data.offsetPosition);
    } else {
      var offset = new Vector2(this.shape.bounds.left, this.shape.bounds.top);
      this.handleOnMouseOver(data.currentPosition, offset);
    }

  }

  // Method to handle the onMouseUp event
  function onMouseUp(data) {

    if (!this.editing) return;

    this.resetDefaults();

  }

  return TextElement;

})();
